import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCopyOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M27 4H9v-.62C9 2.62 9.62 2 10.38 2h17.24c.76 0 1.38.62 1.38 1.38v19.24c0 .76-.62 1.38-1.38 1.38H27z" /><path fill="currentColor" fillRule="evenodd" d="M4.38 8h17.24c.76 0 1.38.62 1.38 1.38v19.24c0 .76-.62 1.38-1.38 1.38H4.38C3.62 30 3 29.38 3 28.62V9.38C3 8.62 3.62 8 4.38 8M5 10v18h16V10z" clipRule="evenodd" /></svg>;
export default SvgIconCopyOutlined;